import { Injectable } from '@angular/core';
import { LocalStorageService } from './local-storage.service';
import { UserDetails } from '@app/models/user-details.model';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private localStorageService: LocalStorageService) {}
  private userDetailsKey = 'userDetails';

  setUserDetails(details: UserDetails) {
    this.localStorageService.setItem(this.userDetailsKey, JSON.stringify(details));
  }

  getUserDetails() {
    const details = this.localStorageService.getItem(this.userDetailsKey);
    return details ? JSON.parse(details) : null;
  }

  clearUserDetails() {
    this.localStorageService.removeItem(this.userDetailsKey);
  }
}
